import { render, staticRenderFns } from "./converdetail.vue?vue&type=template&id=56e66d78"
import script from "./converdetail.vue?vue&type=script&lang=js"
export * from "./converdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports